export default "__VITE_ASSET__HBsySxPC__"